<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="company">
        <el-input v-model="queryParams.company" placeholder="公司名称"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item prop="protocol">
        <el-select v-model="queryParams.protocol" filterable placeholder="请输入协议号" @change="search" clearable >
          <el-option v-for="item in protocolList" :key="item.value" :label="item.value" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="operationName">
        <el-select v-model="queryParams.operationName" multiple filterable placeholder="请输入运营商" @change="search" clearable >
          <el-option v-for="item in operationNames" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="ip" >
        <el-input v-model="queryParams.ip" placeholder="请输入IP/域名"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="orientationNum" >
        <el-input v-model="queryParams.orientationNum" placeholder="请输入定向编号"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item  prop="status" >
        <el-select v-model="queryParams.status" filterable placeholder="请选择状态" @change="search" clearable >
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="remark" >
        <el-input v-model="queryParams.remark" placeholder="备注内容"  @keyup.enter.native="search" clearable ></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleBatch"  v-hasPermi="['agent:orientation:save']">添加</el-button>
        <el-button type="primary" icon="el-icon-upload" @click="handleImport" class="button-class" v-hasPermi="['agent:orientation:import']">导入</el-button>
        <el-button type="primary" class="el-icon-download" @click="handleExport" v-hasPermi="['agent:orientation:export']">导出</el-button>
        <el-button type="success" class="el-icon-s-tools" @click="batchSetting" v-hasPermi="['agent:orientation:batchUpdate']">批量设置</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        
      </el-form-item>
    </el-form>
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border @selection-change="handleSelectionChange">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" class="table-expand">
              <el-row>
                <el-col :span="12">
                  <!-- 缩小距离展示  避免影藏过多内容 -->
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="创建时间：" >
                        <span>{{ props.row.createTime }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="创建人：" >
                        <span>{{ props.row.createUser }}</span>
                      </el-form-item>
                    </el-col>
                    
                  </el-row>
                </el-col>
              </el-row>
              
            </el-form>
          </template>
        </el-table-column>
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="company" label="公司名称" align="center" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="operationName" label="运营商" width="100" align="center"></el-table-column>
        <el-table-column prop="protocol" label="协议号" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ip" label="IP地址/域名" align="center" min-width="160" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!-- 核心：加外层容器，用flex布局分隔文字和图标 -->
            <div class="ip-cell-container" v-if="scope.row.ip">
              <!-- IP文字区域：单独做溢出隐藏 -->
              <span class="ip-text">{{ scope.row.ip }}</span>
              <!-- 复制图标：独立显示，不受文字隐藏影响 -->
              <el-tooltip 
                v-if="scope.row.ip" 
                class="item" 
                effect="dark" 
                :content="$t('app.common.copy')" 
                placement="top-start"
              >
                <i 
                  style="font-size:16px;margin-left:2px;cursor:pointer" 
                  class="el-icon-document-copy" 
                  @click="copy(scope.row.ip)" 
                ></i>
              </el-tooltip>
            </div>
            <div class="ip-cell-container" v-if="scope.row.url">
              <!-- IP文字区域：单独做溢出隐藏 -->
              <span class="ip-text">{{ scope.row.url }}</span>
              <!-- 复制图标：独立显示，不受文字隐藏影响 -->
              <el-tooltip 
                v-if="scope.row.url" 
                class="item" 
                effect="dark" 
                :content="$t('app.common.copy')" 
                placement="top-start"
              >
                <i 
                  style="font-size:16px;margin-left:2px;cursor:pointer" 
                  class="el-icon-document-copy" 
                  @click="copy(scope.row.url)" 
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="addressSource" label="备案公司" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!-- 核心：加外层容器，用flex布局分隔文字和图标 -->
            <div class="ip-cell-container">
              <!-- IP文字区域：单独做溢出隐藏 -->
              <span class="ip-text">{{ scope.row.addressSource }}</span>
              <!-- 复制图标：独立显示，不受文字隐藏影响 -->
              <el-tooltip 
                v-if="scope.row.addressSource" 
                class="item" 
                effect="dark" 
                :content="$t('app.common.copy')" 
                placement="top-start"
              >
                <i 
                  style="font-size:16px;margin-left:2px;cursor:pointer" 
                  class="el-icon-document-copy" 
                  @click="copy(scope.row.addressSource)" 
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="filing" label="备案号" align="center" width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!-- 核心：加外层容器，用flex布局分隔文字和图标 -->
            <div class="ip-cell-container">
              <!-- IP文字区域：单独做溢出隐藏 -->
              <span class="ip-text">{{ scope.row.filing }}</span>
              <!-- 复制图标：独立显示，不受文字隐藏影响 -->
              <el-tooltip 
                v-if="scope.row.filing" 
                class="item" 
                effect="dark" 
                :content="$t('app.common.copy')" 
                placement="top-start"
              >
                <i 
                  style="font-size:16px;margin-left:2px;cursor:pointer" 
                  class="el-icon-document-copy" 
                  @click="copy(scope.row.filing)" 
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orientationNum" label="定向编号" align="center" min-width="180" :show-overflow-tooltip="true">
          <template slot="header">
            <span>定向编号</span>
            <el-tooltip class="item" v-if="checkPermi(['system:dict:edit'])" effect="dark" content="编辑定向提醒" placement="top">
              <i
                style="font-size:14px;margin-left:4px;cursor:pointer;color:#409EFF"
                class="el-icon-edit"
                @click="handleEditOrientation"
              ></i>
            </el-tooltip>
            <el-tooltip class="item" v-else effect="dark" content="定向提醒" placement="top">
              <i
                style="font-size:14px;margin-left:4px;cursor:pointer;color:#409EFF"
                class="el-icon-view"
                @click="handleEditOrientation"
              ></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <!-- 核心：加外层容器，用flex布局分隔文字和图标 -->
            <div class="ip-cell-container">
              <!-- IP文字区域：单独做溢出隐藏 -->
              <span class="ip-text">{{ scope.row.orientationNum }}</span>
              <!-- 复制图标：独立显示，不受文字隐藏影响 -->
              <el-tooltip 
                v-if="scope.row.orientationNum" 
                class="item" 
                effect="dark" 
                :content="$t('app.common.copy')" 
                placement="top-start"
              >
                <i 
                  style="font-size:16px;margin-left:2px;cursor:pointer" 
                  class="el-icon-document-copy" 
                  @click="copy(scope.row.orientationNum)" 
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true"></el-table-column>
        <!-- 提交时间 -->
        <el-table-column prop="submitTime" label="提交时间" width="110" align="center">
          <template slot-scope="{row}">
            <span :title="row.submitTime">{{ row.submitTime ? row.submitTime.split(' ')[0] : '' }}</span>
          </template>
        </el-table-column> 
        <!-- 预计运营商审核完成时间 -->
        <el-table-column prop="uploadTime" label="预计生效时间" width="110" align="center">
          <template slot-scope="{row}">
            <span :title="row.uploadTime">{{ row.uploadTime ? row.uploadTime.split(' ')[0] : '' }}</span>
          </template>
        </el-table-column>   
        <el-table-column prop="status" label="状态" align="center" width="80">
            <template slot-scope="{row}">
              <el-tag type="info" v-if="row.status =='1'">审核中</el-tag>
              <el-tag type="success" v-else-if="row.status =='2'">已审核</el-tag>
              <el-tag type="danger" v-else>作废</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="handleCopy(row)" v-hasPermi="['agent:orientation:copy']">复制</el-button>
            <el-button type="text" size="mini" @click="handleUpdate(row)" v-hasPermi="['agent:orientation:update']">编辑</el-button>
            <el-button type="text" size="mini" @click="handleDel(row)" v-hasPermi="['agent:orientation:del']">作废</el-button>
          </template>
        </el-table-column>
        
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" @close="dialogClose" append-to-body :close-on-click-modal="false">
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" style="text-align: center;" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量添加弹出框 -->
    <el-dialog title="定向添加" :visible.sync="batchFormOpen" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="batchForm" :model="batchForm" :rules="batchRuleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="公司名称" prop="company">
              <el-input v-model="batchForm.company" clearable placeholder="请输入公司名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="运营商" prop="operationNames">
              <el-checkbox-group v-model="batchForm.operationNames">
                <el-checkbox label="中国移动" >中国移动</el-checkbox>
                <el-checkbox label="中国电信" >中国电信</el-checkbox>
                <el-checkbox label="中国联通" >中国联通</el-checkbox>
              </el-checkbox-group>
              <!-- <el-radio v-model="batchForm.operationName" label="中国移动" >中国移动</el-radio>
              <el-radio v-model="batchForm.operationName" label="中国电信" >中国电信</el-radio>
              <el-radio v-model="batchForm.operationName" label="中国联通" >中国联通</el-radio> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="类型" prop="fieldType">
              <el-radio v-model="batchForm.fieldType" label="1" @input="handleFieldTypeChange('1')">IP</el-radio>
              <el-radio v-model="batchForm.fieldType" label="2" @input="handleFieldTypeChange('2')">域名</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="batchForm.fieldType == '2'">
          <el-col :span="24">
            <el-form-item label="协议号" prop="protocols">
              <el-select
                style="width: 100%;"
                v-model="batchForm.protocols"
                clearable
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="请选择协议号">
                <el-option
                  v-for="item in protocolList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="IP/域名列表" prop="url">
              <el-input v-model="batchForm.url" type="textarea" clearable :placeholder="placeholderUrl" rows="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="地址来源" prop="addressSource">
              <el-input v-model="batchForm.addressSource" clearable placeholder="请输入地址来源"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="定向编号" prop="orientationNum">
              <el-input v-model="batchForm.orientationNum" clearable placeholder="请输入定向编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="batchForm.remark" type="textarea" clearable placeholder="请输入备注" rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitBatchForm" :loading="submitLoading">确 定</el-button>
        <el-button @click="cancelBatchForm">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 定向编辑 -->
    <el-dialog title="定向修改" :visible.sync="updateFormOpen" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="updateForm" :model="updateForm" :rules="updateRuleForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="公司名称" prop="company">
              <el-input v-model="updateForm.company" clearable placeholder="请输入公司名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="运营商" prop="operationName">
              <el-radio v-model="updateForm.operationName" label="中国移动" >中国移动</el-radio>
              <el-radio v-model="updateForm.operationName" label="中国电信" >中国电信</el-radio>
              <el-radio v-model="updateForm.operationName" label="中国联通" >中国联通</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="协议号" prop="protocol">
              <el-autocomplete
                class="inline-input"
                clearable
                v-model="updateForm.protocol"
                :fetch-suggestions="querySearch"
                placeholder="输入协议号"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="IP" prop="ip">
              <el-input v-model="updateForm.ip" clearable placeholder="请输入IP"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="域名" prop="url">
              <el-input v-model="updateForm.url" clearable placeholder="请输入域名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备案号" prop="filing">
              <el-input v-model="updateForm.filing" clearable placeholder="请输入域名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="地址来源" prop="addressSource">
              <el-input v-model="updateForm.addressSource" clearable placeholder="请输入地址来源"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="定向编号" prop="orientationNum">
              <el-input v-model="updateForm.orientationNum" clearable placeholder="请输入定向编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="updateForm.remark" type="textarea" clearable placeholder="请输入备注" rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpdateForm" :loading="updateLoading">确 定</el-button>
        <el-button @click="cancelUpdateForm">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 批量设置 -->
    <el-dialog title="定向设置" :visible.sync="batchSettingOpen" width="680px" append-to-body :close-on-click-modal="false">
      <el-form ref="batchSettingForm" :model="batchSettingForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="提交时间" prop="submitTime">
              <el-date-picker
              v-model="batchSettingForm.submitTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="提交时间"
              clearable
            ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="预计生效时间" prop="uploadTime">
              <el-date-picker
              v-model="batchSettingForm.uploadTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="预计生效时间"
              clearable
            ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="定向编号" prop="orientationNum">
              <el-input v-model="batchSettingForm.orientationNum" clearable placeholder="请输入定向编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="batchSettingForm.remark" type="textarea" clearable placeholder="请输入备注" rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSettingForm" :loading="updateLoading">确 定</el-button>
        <el-button @click="cancelSettingForm">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑定向编号对话框 -->
    <el-dialog title="定向编号提醒" :visible.sync="editOrientationOpen" width="1200px" append-to-body :close-on-click-modal="false">
      <div style="margin-bottom: 10px; text-align: right;" v-if="checkPermi(['system:dict:edit'])">
        <i
          class="el-icon-circle-plus"
          style="font-size: 24px; color: #409EFF; cursor: pointer;"
          @click="addRow"
        ></i>
      </div>
      <el-table :data="dictDataList" style="width: 100%" border>
        <el-table-column prop="date" label="日期" width="160">
          <template slot-scope="scope">
            <template v-if="editingRow === scope.row">
              <el-date-picker v-model="scope.row.dictLabel" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:135px"></el-date-picker>
            </template>
            <template v-else>
              {{ scope.row.dictLabel }}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="200">
          <template slot-scope="scope">
            <template v-if="editingRow === scope.row">
              <el-input v-model="scope.row.dictValue" placeholder="请输入内容"></el-input>
            </template>
            <template v-else>
              {{ scope.row.dictValue }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" v-if="checkPermi(['system:dict:edit'])">
          <template slot-scope="scope">
            <template v-if="editingRow === scope.row">
              <el-button type="primary" size="mini" @click="saveEdit">保存</el-button>
              <el-button size="mini" @click="cancelEdit">取消</el-button>
            </template>
            <template v-else>
              <el-button type="primary" size="mini" @click="editRow(scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="deleteRow(scope.row,scope.$index)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { orientationList , saveOrientationBatch , updateOrientation , exportOrientation , batchUpdateOrientation ,delOrientation} from "@/api/api.js";
import { listData, delData, addData, updateData } from "@/api/system.js";
import { getToken } from '@/utils/auth'
export default {
  name: "orientationList",
  data() {
    return{
      queryParams:{
        company:undefined,
        protocol:undefined,
        operationName:undefined,
        orientationNum:undefined,
        ip:undefined,
        url:undefined,
        remark:undefined,
        status:undefined
      },
      tableData:[],
      dateRange:[],
      page: 1,
      pageSize: 20,
      total:0,
      operationNames:['中国移动','中国联通','中国电信'],
      protocolList:[
        { value: 'http' }, { value: 'https' },{ value: 'websocket' }, { value: 'any' },
        { value: 'ftp' }, { value: 'ftps' }, { value: 'sftp' },
        { value: 'tftp' }, { value: 'ssh' }, { value: 'telnet' },
        { value: 'rdp' }, { value: 'vnc' }, { value: 'smtp' },
        { value: 'smtps' }, { value: 'pop3s' }, { value: 'pop3' },
        { value: 'imaps' }, { value: 'imap' }, { value: 'ntp' },
        { value: 'snmp' }, { value: 'ldap' }
      ],
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        headers: { Authorization: getToken()},
        // 上传的地址
        url: "/cms/orientation/import",
      },
      batchFormOpen:false,
      submitLoading:false,
      batchForm:{
        operationNames:[],
        fieldType:"1",
        company:undefined,
        protocols:[],
        url:undefined,
        addressSource:undefined,
        orientationNum:undefined,
        remark:undefined
      },
      placeholderUrl:"请输入IP，每个IP占一行 \n192.168.1.1\n12.13.1.2",
      batchRuleForm: {
        operationNames: [
          { required: true, message: "请选择运营商", trigger: "blur" },
        ],
        company: [
          { required: true, message: "公司名称不能为空", trigger: "blur" },
        ],
        
        url: [
          { required: true, message: "IP/域名不能为空", trigger: "blur" },
        ]
      },
      updateFormOpen:false,
      updateLoading:false,
      updateForm:{
        id:undefined,
        operationName:"中国移动",
        company:undefined,
        protocol:undefined,
        ip:undefined,
        url:undefined,
        filing:undefined,
        addressSource:undefined,
        orientationNum:undefined,
        remark:undefined
      },
      updateRuleForm: {
        company: [
          { required: true, message: "公司名称不能为空", trigger: "blur" },
        ]
      },
      selectedIds:[],
      batchSettingOpen:false,
      batchSettingForm:{
        submitTime:undefined,
        uploadTime:undefined,
        orientationNum:undefined,
        remark:undefined
      },
      editOrientationOpen:false,
      editOrientationLoading:false,
      dictDataList:[],
      editingRow: null,
      statusList:[
        { value: '1', label: '审核中' },
        { value: '2', label: '已审核' },
        { value: '0', label: '作废' }
      ]
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var protocolList = this.protocolList;
      var results = queryString ? protocolList.filter(this.createFilter(queryString)) : protocolList;
      cb(results);
    },
    createFilter(queryString) {
      return (protocol) => {
        return (protocol.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 多选
    handleSelectionChange(arrlist){
      this.selectedIds = arrlist.map(item=>item.id);
    },
    // 获取列表的数据
    initData(){
      let params = {
        model: {
          ... this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      orientationList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.queryParams = {
        company:undefined,
        protocol:undefined,
        operationName:undefined,
        orientationNum:undefined,
        ip:undefined,
        url:undefined,
        remark:undefined,
        status:undefined
      } 
      this.search();
    },
    handleImport() {
      this.upload.title = "定向导入";
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      this.download('/orientation/importTemplate', {
      }, `orientation_template_${new Date().getTime()}.xlsx`)
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.search();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
    // 关闭弹窗
    dialogClose(){
      this.dialog = false;
      this.initData();
    },
    handleBatch(){
      this.batchForm={
        operationNames:[],
        fieldType:"1",
        company:undefined,
        protocols:[],
        url:undefined,
        addressSource:undefined,
        orientationNum:undefined,
        remark:undefined
      }
      this.batchFormOpen = true;
    },
    submitBatchForm(){
      this.$refs["batchForm"].validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          let { url } = this.batchForm;
          let params = {
            ...this.batchForm,
            urls:url ? url.split("\n") : []
          };
          saveOrientationBatch(params).then(res => {
            this.$notify.info({
              title: "提示",
              message: "定向数据已提交",
              duration: 1000,
              offset:30
            });
            this.submitLoading = false;
            this.cancelBatchForm();
            this.resetQuery();
          }).catch(() => {
            this.submitLoading = false;
          })
        } else {
          console.log("校验失败");
        }
      });
    },
    cancelBatchForm(){
      this.resetForm('batchForm');
      this.batchFormOpen = false;
    },
    handleExport(){
      let params = {
        ...this.addDateRange(this.queryParams, this.dateRange),
      }
      exportOrientation(params).then(res=>{
        if (res.data.code == 200) {
          this.$notify({
            title: "提示",
            message: "已提交导出，请在任务中心查看进度",
            type: "success",
            offset:30
          });
          setTimeout(()=>{
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    handleUpdate(row){
      this.updateForm = {...row};
      this.updateFormOpen = true;
    },
    //编辑
    submitUpdateForm(){
      this.$refs["updateForm"].validate((valid) => {
        if (valid) {
          this.updateLoading = true;
          let params = {
            ...this.updateForm,
          };
          updateOrientation(params).then(res => {
            this.$notify.info({
              title: "提示",
              message: "定向数据已更新",
              duration: 1000,
              offset:30
            });
            this.updateLoading = false;
            this.cancelUpdateForm();
            // this.resetQuery();
            this.search();

          }).catch(() => {
            this.updateLoading = false;
          })
        }
      })
    },
    cancelUpdateForm(){
      this.resetForm('updateForm');
      this.updateFormOpen = false;
    },
    handleCopy(row){
      this.batchForm.operationNames = [row.operationName];
      this.batchForm.company = row.company;
      this.batchForm.protocols = [row.protocol];
      this.batchForm.fieldType = row.ip ? '1' : '2';
      this.batchForm.url = row.url || row.ip;
      this.batchForm.addressSource = row.addressSource;
      this.batchForm.orientationNum = row.orientationNum;
      this.batchForm.remark = row.remark;
      this.batchFormOpen = true;
    },
    // 处理类型切换事件
    handleFieldTypeChange(type) {
      if (type === '1') {
        this.batchForm.protocol = undefined;
        this.placeholderUrl = "请输入IP，每个IP占一行 \n192.168.1.1\n12.13.1.2";
      } else if (type === '2') {
        this.batchForm.url = undefined;
        this.placeholderUrl = "请输入域名和备案号，域名和备案号用|隔开，每个域名和备案号占一行 \niot.juzi1688.cn|粤ICP备20056666号\njuzi1688.cn|粤ICP备20058888号";
      }
    },
    batchSetting(){
      this.batchSettingOpen = true;
    },
    cancelSettingForm(){
      this.resetForm('batchSettingForm');
      this.batchSettingOpen = false;
    },
    submitSettingForm(){
      let params = {
        ids:this.selectedIds,
        ...this.batchSettingForm,
      };
      batchUpdateOrientation(params).then(res => {
        this.$notify.info({
          title: "提示",
          message: "定向数据已更新",
          duration: 1000,
          offset:30
        });
        this.batchSettingOpen = false;
        this.cancelSettingForm();
        this.resetQuery();

      }).catch(() => {
        this.updateLoading = false;
      })
    },
    // 定向编号提示语修改
    handleEditOrientation(){
      this.editOrientationOpen = true;
      this.getDictList();
    },
    getDictList() {
      let params = {
        model:{
          dictType:'sys_orientation_notice'
        },
        page: 1,
        pageSize: 500,
      }
      listData(params).then(res => {
        this.dictDataList = res.data.data.records;
      });
    },
    // 新增行
    addRow(){
      const dictSort = Math.max(...this.dictDataList.map(item => item.dictSort), 0) + 1;
      this.dictDataList.push({
        dictSort: dictSort,
        dictLabel: '',
        dictValue: ''
      });
    },
    // 编辑行
    editRow(row){
      this.editingRow = row;
    },
    // 保存编辑
    saveEdit(){
      const params = {
        id: this.editingRow.id,
        dictLabel: this.editingRow.dictLabel,
        dictValue: this.editingRow.dictValue,
        dictType:"sys_orientation_notice",
        cssClass: undefined,
        listClass: 'default',
        dictSort: this.editingRow.dictSort,
        status: "0",
      };
      if (params.id != undefined) {
        updateData(params).then(res => {
          this.editingRow = null
          this.$modal.msgSuccess("修改成功");
        });
      } else {
        addData(params).then(res => {
          this.editingRow = null
          this.$modal.msgSuccess("新增成功");
        });
      }
      
    },
    // 取消编辑
    cancelEdit(){
      this.editingRow = null;
    },
    // 删除行
    deleteRow(row,index){
      this.dictDataList.splice(index, 1);
      if(row.id){
        delData(row.id);
      }
    },
    handleDel(row){
      this.$confirm('确认作废吗此定向记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delOrientation({id:row.id}).then(res => {
          this.$notify.info({
            title: "提示",
            message: "定向数据已作废",
            duration: 1000,
            offset:30
          });
          this.resetQuery();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消作废'
        });
      });
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    },

  },
  created() {
    this.initData();
  }
};
</script>
<style scoped lang="less">
  /* 表格单元格容器：flex布局，让文字占满空间，图标固定 */
  .ip-cell-container {
    display: flex;
    align-items: center;  /* 文字和图标垂直居中 */
    width: 100%;  /* 占满表格单元格宽度 */
  }

  /* IP文字区域：超出隐藏+省略号 */
  .ip-text {
    flex: 1;  /* 占满容器剩余空间（图标外的所有宽度） */
    overflow: hidden;  /* 超出隐藏 */
    text-overflow: ellipsis;  /* 超出显示省略号 */
    white-space: nowrap;  /* 强制不换行 */
    margin-right: 4px;  /* 文字和图标之间留一点间距，避免贴太紧 */
  }
  .table-expand{
    margin-left: 20px;
    label{
      width: 90px;
      color: #99a9bf; 
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }

</style>


